<template>
    <l-marker
        :location="userLocation"
        :lat-lng="userLocation.getLatLong()"
        :visible="userLocation.isVisible()"
        @click="handleMarkerClick()"
    >
        <l-icon
            className="map-location-marker"
            :iconSize="[22, 22]"
        >
            <img :src="getUserIcon(userLocation)" />
            <span
                v-if="displayCallsign"
                class="map-location-marker-label"
            >
                {{ callsign }}
            </span>

            <l-popup :content="popupContent" />
        </l-icon>
    </l-marker>
</template>

<script>
import { LMarker, LIcon, LPopup } from '@vue-leaflet/vue-leaflet'

export default {
    components: {
        LMarker,
        LIcon,
        LPopup,
    },

    props: {
        userLocation: {
            type: Object,
            required: true,
        },
        groups: {
            type: Array,
            required: true,
        },
        displayCallsign: {
            type: Boolean,
            default: true,
        },
    },

    computed: {
        popupContent() {
            const user = this.userLocation
            const groups = this.userGroups
            /* eslint-disable vue/script-indent */
            const content = `
                <div class="map-location-marker-label map-location-marker-label--full">
                    <div class="user-detail">
                        <p class="user-detail__row">${user.getLabel()}</p>
                        <p class="user-detail__row">
                            <span class="user-detail__label">gid</span>
                            <span class="user-detail__value">
                                ${user.user.gid}
                            </span>
                        </p>
                        <p class="user-detail__row user-detail__label">
                            last update
                        </p>
                        <p class="user-detail__row">
                            ${user.latitude}, ${user.longitude}
                        </p>
                        <p class="user-detail__row">${this.lastUpdatedLocalTime}</p>
                        <div class="user-groups">
                            ${groups.map(
                                (g) => `<span class='user-group user-group--${this.getIconBgColor(g)}'>${g.name}</span>`
                            )}
                        </div>
                    </div>
                </div>
            `
            /* eslint-disable vue/script-indent */
            return content
        },

        callsign() {
            return this.userLocation.getLabel()
        },

        lastUpdatedLocalTime() {
            const { timestamp } = this.userLocation

            return window.moment.unix(timestamp).local().format('M/DD/YYYY HH:mm:ss')
        },

        userGroups() {
            return this.groups.filter((group) =>
                group.userLocations.find((userLocation) => userLocation.gid === this.userLocation.gid)
            )
        },

        renderUserGroups() {
            if (this.userGroups.length > 0) {
                this.userGroups.forEach((g) => `${g.name}`)
            }
            return ''
        },
    },

    methods: {
        getIconBgColor(group) {
            return group.getIcon().replace('marker-', '')
        },
        handleMarkerClick() {
            const { userLocation } = this

            this.$nextTick(() => {
                const userDetailsElement = document.querySelectorAll('.map-location-marker-label--full')
                const userGroupsElement = document.querySelectorAll('.user-groups')

                const { height: userDetailsHeight } =
                    userDetailsElement[userDetailsElement.length - 1].getBoundingClientRect()
                const { height: userGroupsHeight } =
                    userGroupsElement[userGroupsElement.length - 1].getBoundingClientRect()

                const detailsElementHeight = userDetailsHeight + userGroupsHeight
                const bounds = {
                    lat: userLocation.latitude,
                    lng: userLocation.longitude,
                }

                this.$emit('panToFitMarker', bounds, detailsElementHeight)
            })
        },
        getUserIcon(user) {
            return !user.isStale() && !user.isInactive()
                ? `/images/map/${user.getIcon()}.svg`
                : `/images/map/${user.getIcon()}-stale.svg`
        },
    },
}
</script>
